import React, { useState } from 'react';

const CenteredAlert = ({ message = "This is an alert!", duration = 3000 }) => {
  const [visible, setVisible] = useState(false);

  const showAlert = () => {
    setVisible(true);
    setTimeout(() => setVisible(false), duration);
  };

  return (
    <>
      <button onClick={showAlert}>Show Alert</button>

      {visible && (
        <div style={styles.overlay}>
          <div style={styles.alertBox}>
            <p>{message}</p>
          </div>
        </div>
      )}
    </>
  );
};

const styles = {
  overlay: {
    position: 'fixed',
    top: 0,
    left: 0,
    height: '100vh',
    width: '100vw',
    backgroundColor: 'rgba(0,0,0,0.3)',
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    zIndex: 9999
  },
  alertBox: {
    backgroundColor: '#fff',
    padding: '24px 40px',
    borderRadius: '12px',
    boxShadow: '0 4px 10px rgba(0,0,0,0.3)',
    fontSize: '18px',
    fontWeight: '500',
    textAlign: 'center'
  }
};

export default CenteredAlert;
